/** 险种页 + 行业页：页面路径与 FAQ 后缀 */

export const PRODUCT_INDUSTRY_PAGE_KEYS = [
  'directorsOfficers',
  'mergersAcquisitions',
  'cyberSecurity',
  'propertyCasualty',
  'employeeBenefits',
  'globalClients',
  'privateEquity',
  'lifeScience',
  'financialInstitutions',
  'realEstateConstructions',
  'automotiveInfrastructure',
  'manufacturingTechnology',
  'foodBeverage',
  'energyPower',
  'sportsEntertainmentEvents'
]

export const PAGE_PATH_BY_KEY = {
  mainContent: '/',
  directorsOfficers: '/directorsOfficers',
  mergersAcquisitions: '/mergersAcquisitions',
  cyberSecurity: '/cyberSecurity',
  propertyCasualty: '/propertyCasualty',
  employeeBenefits: '/employeeBenefits',
  globalClients: '/globalClients',
  privateEquity: '/privateEquity',
  lifeScience: '/lifeScience',
  financialInstitutions: '/financialInstitutions',
  realEstateConstructions: '/realEstateConstructions',
  automotiveInfrastructure: '/automotiveInfrastructure',
  manufacturingTechnology: '/manufacturingTechnology',
  foodBeverage: '/foodBeverage',
  energyPower: '/energyPower',
  sportsEntertainmentEvents: '/sportsEntertainmentEvents',
  aboutUs: '/AboutUs',
  companyFacts: '/companyFacts',
  newsPage: '/news'
}

const SITE_URL = 'https://www.swiglobal.com'

export function buildFaqCta(pageKey, locale = 'CN') {
  const path = PAGE_PATH_BY_KEY[pageKey] || '/'
  const url = `${SITE_URL}${path}`
  if (locale === 'EN') {
    return ` For more details, please submit an inquiry on our website: ${url}`
  }
  return `如需了解更多详细信息，欢迎访问官网填写留言表单：${url}`
}

export function appendFaqCta(answer, pageKey, locale = 'CN') {
  const cta = buildFaqCta(pageKey, locale)
  if (answer.includes('填写留言表单') || answer.includes('submit an inquiry on our website')) {
    return answer
  }
  return `${answer}${cta}`
}

export function shouldAppendCta(pageKey) {
  return PRODUCT_INDUSTRY_PAGE_KEYS.includes(pageKey)
}

export function processGeoFaq(geoFaq, pageKey, locale = 'CN', supplementItems = []) {
  if (!geoFaq) return geoFaq

  const items = [...(geoFaq.items || []), ...supplementItems]
  const processedItems = shouldAppendCta(pageKey)
    ? items.map((item) => ({ ...item, a: appendFaqCta(item.a, pageKey, locale) }))
    : items

  return {
    ...geoFaq,
    items: processedItems
  }
}
